export const MAX_PROFILE_WIDTH = 752;
